import DesignShell from '../components/DesignShell';
import { getDoc } from '../content/docs';

// The ADO Pipelines catalogue is authored in content/pipelines/docs/overview.md
// (a local platform staged into the docs bundle). Render it in the Site design
// style; the per-pipeline detail docs remain browsable at /docs/pipelines/*.
export default function SitePipelines() {
  const doc = getDoc('pipelines/overview');
  return (
    <DesignShell
      title="ADO Pipelines"
      subtitle="Every Azure DevOps pipeline that builds or deploys the platform — infrastructure, application, and the master-record site — with the publish-chain ordering and naming conventions."
      markdown={
        doc?.content ??
        'Pipeline documentation has not been published yet — run the site content build.'
      }
    />
  );
}
